"use client"

export const removeFreeShipping = async () => {
    try {
        const response = await fetch("/api/centra/remove-free-shipping", {
            method: "DELETE",
            headers: { "Content-Type": "application/json" }
        })

        const data = await response.json()
        if (!response.ok) {
            console.error("Remove free shipping API error:", {
                status: response.status,
                error: data.error
            })
            throw new Error(data.error || `HTTP error! status: ${response.status}`)
        }

        if (data.success) {
            return { success: true, data: data.data }
        } else {
            throw new Error(data.error || "Failed to remove free shipping")
        }
    } catch (error) {
        console.error("Error removing free shipping:", error)
        throw error
    }
}

export default removeFreeShipping
